// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Type_AnnEquality from "../Type.AnnEquality/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Result.functorResult);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil));
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(/* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString)));
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var ReadOnly = function (x) {
    return x;
};
var queryReadOnly$prime = function (dictTypeEquals) {
    var from = Type_Equality.from(dictTypeEquals);
    return {
        queryImpl: function (v) {
            return function (v1) {
                return Restaumatic_Form_DynamicResult.unsafeStrenghten(Restaumatic_Form_DynamicResult.wrap(map((function () {
                    var $66 = Restaumatic_Form_Result.mapErrors(Restaumatic_Form_Internal.tagErrors(v1.name)(Data_Maybe.Nothing.value));
                    var $67 = map1(from);
                    return function ($68) {
                        return $66($67(Restaumatic_Form_Result.liftV($68)));
                    };
                })())(Restaumatic_Form_Final.unFinalV(v1.value))));
            };
        }
    };
};
var queryImpl = /* #__PURE__ */ Restaumatic_Form_Query.queryImpl(/* #__PURE__ */ queryReadOnly$prime(Type_Equality.refl));
var initializeSomeInitializer = {
    makeImpl: Restaumatic_Form_Internal.makeWithSomeInitializer
};
var initializeSomeInitializer1 = {
    makeImpl: Restaumatic_Form_Internal.makeWithSomeInitializer
};
var initializeNoInitializerRe = function () {
    return {
        makeImpl: function (v) {
            return Partial_Unsafe.unsafeCrashWith("undefined");
        }
    };
};
var initializeNoInitializerRe1 = function () {
    return {
        makeImpl: function (v) {
            return Partial_Unsafe.unsafeCrashWith("undefined");
        }
    };
};
var initializeNoInitialValueR = function (dictAnnTypeEquals) {
    var to = Type_AnnEquality.to(dictAnnTypeEquals);
    return {
        makeImpl: function (p) {
            return function (opts) {
                return function (v) {
                    return function (initializer) {
                        return pure({
                            name: opts.name,
                            value: to(p)(initializer)
                        });
                    };
                };
            };
        }
    };
};
var initializeNoInitialValueR1 = function (dictAnnTypeEquals) {
    var to = Type_AnnEquality.to(dictAnnTypeEquals);
    return function (dictAnnTypeEquals1) {
        var to1 = Type_AnnEquality.to(dictAnnTypeEquals1);
        return {
            makeImpl: function (p) {
                return function (opts) {
                    return function (v) {
                        return function (initializer) {
                            return pure({
                                name: opts.name,
                                value: Restaumatic_Form_Final.liftDynamic(map(to1(p))(to(p)(initializer)))
                            });
                        };
                    };
                };
            }
        };
    };
};
var initializeEffectInitializ = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithEffectInitializer(dictInitialize)
    };
};
var initializeEffectInitializ1 = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithEffectInitializer(dictInitialize)
    };
};
var dumpStateReadOnly$prime = {
    dumpState: function (v) {
        return pure1(encode({}));
    }
};
var addErrorsReadOnly$prime = {
    addErrors: function (v) {
        return function (v1) {
            return pure2(Data_Unit.unit);
        };
    }
};
var addContextReadOnly$prime = {
    addContext: function (v) {
        return function (v1) {
            return pure2(Data_Unit.unit);
        };
    }
};
var errors = function (v) {
    var getErrors = (function () {
        var $69 = map2(function (v1) {
            return v1.message;
        });
        var $70 = Data_Array.filter(function ($74) {
            return !(function (v1) {
                return v1.internal;
            })($74);
        });
        var $71 = Data_Maybe.fromMaybe([  ]);
        var $72 = lookup(new Data_Maybe.Just(v.name));
        return function ($73) {
            return $69($70($71($72(unwrap($73)))));
        };
    })();
    return map(getErrors)(Restaumatic_Form_DynamicResult.errors(queryImpl(Restaumatic_Form_Query.Strict.value)(v)));
};
export {
    ReadOnly,
    errors,
    initializeNoInitializerRe1,
    initializeEffectInitializ1,
    initializeSomeInitializer1,
    initializeNoInitialValueR1,
    initializeNoInitializerRe,
    initializeEffectInitializ,
    initializeSomeInitializer,
    initializeNoInitialValueR,
    queryReadOnly$prime,
    addContextReadOnly$prime,
    dumpStateReadOnly$prime,
    addErrorsReadOnly$prime
};
